<template>
    <CModal
      :title="title"
      :color="color"
      size="lg"
      :show.sync="showModal"
    >   
        <CForm>
            <CRow>
               <CCol md="6">
                <CInput
                  label="Nombre:"
                  type="text"
                  name="name"
                  :lazy="false"
                  :value.sync="$v.form.name.$model"
                  :isValid="checkIfValid('name')"
                  placeholder=""
                  autocomplete="given-name"
                  invalidFeedback="Este campo es requerido y debe ser mayor a 2 caracteres."
                />
              </CCol>
              <CCol md="6">
                <CSelect
                  label="Tipo:"
                  id="type"
                  name="type"
                  :value.sync="$v.form.type.$model"
                  :options="typeOptions"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol md="12">
                <label for="description">Descripción:</label>
                  <textarea
                    class="form-control"
                    id="description"
                    name="description"
                    rows="2"
                    v-model.trim="$v.form.description.$model"
                    :isValid="checkIfValid('description')"
                    placeholder=""
                    autocomplete="given-description"
                  ></textarea>
                  <div v-if="!checkIfValid('description')" class="invalid-feedback">
                    Este campo es requerido y debe ser mayor a 2 caracteres.
                  </div>
              </CCol>
            </CRow>
            <br>
            <CRow>
              <CCol md="6">
                <CSelect
                  label="Enfoque:"
                  id="target_group"
                  name="target_group"
                  :value.sync="$v.form.target_group.$model"
                  :options="targetGroupOptions"
                />
              </CCol>
              <CCol md="6">
                <CInput
                  type="text"
                  name="target"
                  id="target"
                  label="Objetivo del concurso (cantidad):"
                  :lazy="false"
                  :value.sync="$v.form.target.$model"
                />
              </CCol>
              <CCol :md="form.target_group === 'recurring' ? 4 : 6">
                <CInput
                  type="text"
                  name="target_min"
                  id="target_min"
                  label="Mínima cantidad para participar:"
                  :lazy="false"
                  :value.sync="$v.form.target_min.$model"
                />
              </CCol>
              <CCol :md="form.target_group === 'recurring' ? 4 : 6">
                <CInput
                  type="text"
                  name="target_max"
                  id="target_max"
                  label="Máxima cantidad para participar:"
                  :lazy="false"
                  :value.sync="$v.form.target_max.$model"
                />
              </CCol>
              <CCol v-show="form.target_group === 'recurring'" md="4">
                <CInput
                  style="font-size: 12px; margin-top: 5px;"
                  type="text"
                  name="target_init"
                  id="target_init"
                  label="Cantidad inicial para calcular el premio:"
                  :lazy="false"
                  :value.sync="$v.form.target_init.$model"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol md="6">
                <CSelect
                  label="Tipo de Premio:"
                  id="award_type"
                  name="award_type"
                  :value.sync="$v.form.award_type.$model"
                  :options="awardTypeOptions"
                />                
              </CCol>
              <CCol md="6">
                <CInput
                  type="text"
                  name="award_amount"
                  id="award_amount"
                  label="Cantidad del premio:"
                  :lazy="false"
                  :value.sync="$v.form.award_amount.$model"
                />
                <div v-if="form.target_group === 'recurring' && estimatedAwardMax !== null"
                    style="font-size: 11px; color: #666; margin-top: 2px; margin-left: 2px;">
                  <i class="fas fa-info-circle"></i> Premiación topada a: {{ estimatedAwardMax }}
                </div>
              </CCol>
            </CRow>
        </CForm>
        <template #footer>
          <CButton @click="closeModal" color="secondary">Cancelar</CButton>
          <CButton v-if="!isEdit" @click="storeObjectives" :color="color">Aceptar</CButton>
          <CButton v-if="isEdit" @click="updateObjectives" :color="color">Actualizar</CButton>
        </template>
    </CModal>
</template>

<script>
import { validationMixin } from "vuelidate"
import { required, numeric, minLength, helpers, requiredIf, requiredUnless } from "vuelidate/lib/validators"

import store from '../../../store'

export default {
  name: 'ChallengeVideoModal',
  props: {
    permissions: Object,
  },
  data () {
    return {
      showModal: false,
      title: "Nuevo Objetivo",
      color: "info",
      isEdit: false,
      form: this.getEmptyForm(),
      submitted: false,
      typeOptions: [
        {label: 'Venta por Monto (Total)', value: 'sales'},
        {label: 'Clientes Cantidad (Diferentes)', value: 'customers'},
        {label: 'Cajas Cantidad (Total)', value: 'boxes'}
      ],
      targetGroupOptions: [
        {label: 'Unico', value: 'unique'},
        {label: 'Repetitivo', value: 'recurring'},
      ],
      awardTypeOptions: [
        {label: 'Puntos Digitales', value: 'digital_points'},
        {label: 'Monedero Electrónico', value: 'wallet'},
        {label: 'Boletos para Evento', value: 'ticket'},
        {label: 'Tarjeta de Regalo', value: 'card'},
        {label: 'Premio Físico', value: 'gift'},
        {label: 'Puntos para Eventos', value: 'event_points'},
        {label: 'Puntos para Certificados', value: 'card_points'},
        {label: 'Puntos para Premios', value: 'gift_points'},
        {label: 'Puntos para Monedero', value: 'wallet_points'}
      ],
      link: '',
      item: false,
      challenge_id: 0,
    }
  },
  mounted: async function() {
    this.challenge_id = await this.$route.params.challenge_id
  },
  methods: {
    storeModal () {
      this.showModal = true;
      this.color = "info";
      this.title = 'Nuevo Objetivo';
      this.isEdit = false;
      this.submitted = false;

      this.form = {
          challenge_id: this.challenge_id,
          name: '',
          type: 'customers',
          description: '',
          target: '',
          target_min: '',
          target_max: '',
          target_init: '',
          target_group: 'unique',
          award_type: 'digital_points',
          award_amount: ''
      }
    },
    editModal (item) {
      this.showModal = true;
      this.color = "warning";
      this.title = 'Editar Objetivo';
      this.isEdit = true;
      this.submitted = false;

      this.form = {
          challenge_id: this.challenge_id,
          name: item.name,
          type: item.type,
          description: item.description,
          target: item.target,
          target_min: item.target_min,
          target_max: item.target_max,
          target_group: item.target_group,
          target_init: item.target_init,
          award_type: item.award_type,
          award_amount: item.award_amount,
          id: item.id
      }
    },
    storeObjectives () {
      this.$v.$touch();
      if (this.isValid) {
        this.submitted = true;

        this.$emit("storeObjectives", this.form );

        this.closeModal();
      }
    },
    updateObjectives () {
      this.$v.$touch();
      if (this.isValid) {
        this.submitted = true;

        this.$emit("updateObjectives", this.form );

        this.closeModal();
      }
    },
    closeModal () {
      this.showModal = false;

      this.form = this.getEmptyForm()
      this.submitted = false
      this.$v.$reset()
    },
    getEmptyForm () {
      return {
          challenge_id: 0,
          name: '',
          type: 'customers',
          description: '',
          target: '',
          target_min: '',
          target_max: '',
          target_group: 'individual',
          award_type: 'digital_points',
          award_amount: '',
          target_init:''
      }
    },
    checkIfValid (fieldName) {
      const field = this.$v.form[fieldName]
      if (!field.$dirty) {
        return null
      }
      
      return !(field.$invalid || field.$model === '')
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    },
  },
  computed: {
    formString () { return JSON.stringify(this.form, null, 4) },
    estimatedAwardMax() {
      const {
        target_group,
        target_max,
        target_init,
        target,
        award_amount
      } = this.form;

      if (target_group !== 'recurring') return null;

      const max = parseFloat(target_max) || 0;
      const init = parseFloat(target_init) || 0;
      const step = parseFloat(target) || 0;
      const amount = parseFloat(award_amount) || 0;

      if (max > 0 && step > 0 && amount > 0) {
        const tramos = Math.floor((max - init + 1) / step);
        return tramos > 0 ? tramos * amount : 0;
      }

      return null;
    },
    isValid () { return !this.$v.form.$invalid },
    isDirty () { return this.$v.form.$anyDirty },
  },
  mixins: [validationMixin],
  validations: {
    form: {
      name: {
        required
      },
      type: {
        required
      },
      description: {
        
      },
      target: {
        required
      },
      target_min: {
        required
      },
      target_max: {
        required
      },
      target_init: {
        
      },
      target_group: {
        required
      },
      award_type: {
        required
      },
      award_amount: {
        required
      },
    }
  },
}
</script>